import React from 'react';
import { useSelector } from 'react-redux';

export default function HomeUserCard() {
  const { userInfo } = useSelector((state) => state.BaseInfo);

  return (
    <div className="bg-card-light flex items-center justify-between rounded-3xl p-4 shadow-sm">
      <div>
        <p className="mb-0.5 text-xs font-semibold text-slate-500">
          {userInfo?.depNm}{' '}
          {userInfo?.posiNm?.split(',').map((text, index) => (
            <React.Fragment key={index}>
              {index > 0 && <br />}
              {text.trim()}
            </React.Fragment>
          ))}
        </p>
        <p className="text-lg leading-tight font-bold">
          안녕하세요, <br />{' '}
          <span className="text-primary">{userInfo?.userNm}</span>{' '}
          {userInfo?.rank}님!
        </p>
      </div>
      <div class="h-12 w-12 shrink-0 overflow-hidden rounded-full border-2 border-slate-50 bg-[#DDB892]">
        {userInfo?.profileImg && (
          <img
            alt="Profile"
            class="h-full w-full object-cover"
            src={userInfo?.profileImg}
          />
        )}
      </div>
    </div>
  );
}
